import { ONLY_FAVORITES_KEY, ONLY_SEEN_KEY } from "./constants";
import { get, set } from "./get-set";

export const getOnlySeen = () => {
  const existingData = get();

  const sortStored = existingData || { [ONLY_SEEN_KEY]: false };

  return sortStored[ONLY_SEEN_KEY];
};

export const getOnlyFavorites = () => {
  const existingData = get();

  const sortStored = existingData || { [ONLY_FAVORITES_KEY]: false };

  return sortStored[ONLY_FAVORITES_KEY];
};

export const saveOnlySeen = (onlySeen: boolean) => {
  const existingData = get();

  const sortStored = existingData || { [ONLY_SEEN_KEY]: false };

  const modifiedData = { ...sortStored, [ONLY_SEEN_KEY]: onlySeen };

  set(modifiedData);
  return modifiedData;
};

export const saveOnlyFavorites = (onlyFavorites: boolean) => {
  const existingData = get();

  const sortStored = existingData || { [ONLY_FAVORITES_KEY]: false };

  const modifiedData = { ...sortStored, [ONLY_FAVORITES_KEY]: onlyFavorites };

  set(modifiedData);
  return modifiedData;
};
